import { ID } from "common/entities/IEntity";
import { Entity, Field } from "typegraph";

@Entity({one: "entry", many: "entries"})
export class Entry {

	@Field()
	public id: ID;

	@Field()
	public startDate: string;

	@Field()
	public endDate: string;

	@Field()
	public displayName: string;

}



// WEBPACK FOOTER //
// ./src/panels/userSubscriptions/entities/Entry.ts